<form [formGroup]="form" (ngSubmit)="submit(form)" errorTailor>
    <div class="modal-header">
        <h4 class="modal-title">{{title}}</h4>
    </div>
    <div class="modal-body">
        <label class="form-label" for="signature">{{label}} <span class="required">*</span></label>
        <input type="text" class="form-control" id="signature" formControlName="signature"
            placeholder="Enter signature"
            [attr.aria-invalid]="signatureControl?.invalid && signatureControl?.touched ? 'true' : null"
            [attr.aria-describedby]="signatureControl?.invalid && signatureControl?.touched ? 'signature-error' : null" />
        <div id="signature-error"
             class="invalid-feedback d-block"
             role="alert"
             controlErrorAnchor>
        </div>
    </div>
    <div class="modal-footer">
        <button type="submit" class="btn btn-success">Authenticate</button>
        <button type="button" class="btn btn-info" (click)="cancel()">Cancel</button>
    </div>
</form>
